import React, { Component } from 'react';
import { Modal, Form, Select } from 'antd';
import { inject, observer } from 'mobx-react/index';
const Option = Select.Option;

@inject('store')
@observer
export class SellStrategyModal extends Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    render() {
        const position = this.props.position;
        return (
            <Modal
                title="Sell Strategy"
                width={450}
                visible={this.props.visible}
                onCancel={() => {
                    this.form.current.resetFields();
                    this.props.onCancel();
                }}
                onOk={() => {
                    this.form.current.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            this.props.store.botStore.actionStore.execute('set_sell_strat', {
                                position_id: position.id,
                                strategy_id: values.strategy_id
                            });
                            this.form.current.resetFields();
                            this.props.onCancel();
                        }
                    });
                }}
            >
                <SellStrategyForm ref={this.form} position={this.props.position} />
            </Modal>
        );
    }
}

@inject('store')
@observer
class SellStrategyFormComponent extends Component {
    render() {
        const { getFieldDecorator } = this.props.form;
        const position = this.props.position;
        if (!position) return null;
        return (
            <Form>
                <Form.Item label="Strategy" required={true}>
                    {getFieldDecorator('strategy_id', {
                        initialValue: position.strategy_id,
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <Select showSearch style={{ width: '100%' }}>
                            {[
                                ...this.props.store.strategyStore.signal,
                                ...this.props.store.strategyStore.buySell
                            ]
                                .sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    if (a.name > b.name) return 1;
                                    return 0;
                                })
                                .filter(s => !s.trigger)
                                .map(s => {
                                    return (
                                        <Option value={s.id} key={s.id}>
                                            {s.name}
                                        </Option>
                                    );
                                })}
                        </Select>
                    )}
                </Form.Item>
            </Form>
        );
    }
}

export const SellStrategyForm = Form.create()(SellStrategyFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/SellStrategyModal.js